export const consultationConditionShow: any = {
  pageTitle: "Proposal from たびチャット",
};
